/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMediaQuery } from "@mui/material";
import bgBrushMobile from "assets/limited-deals/bg-brush-mobile.png";
import bgBrush from "assets/limited-deals/bg-brush.png";
import { waterfallSaleAssets } from "assets/cdn";
import CountdownV2 from "components/CountdownV2";
import { useEnvContext, useWebStoreContext } from "contexts";
import DebugCopyIdButton from "debug/components/DebugCopyIdButton";
import { FeaturesFlags } from "helpers";
import { getVariantImage } from "helpers/getVariantImage";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { useEffect, useState } from "react";
import { offersApi, useGetFeatureTrackerQuery } from "redux/apis";
import {
	selectDialogState,
	// selectPoisBountyV3State,
	setWaterfallResponse
} from "redux/slices";
import { IOffer, ITierStatus, WaterFallCard } from "./lib/WaterFallCard";
import { WaterFallCardV2 } from "./lib/WaterFallCardv2";
import {
	BgBrush,
	Container,
	// ContributeToPoisText,
	Image,
	OffersContainer,
	//timerStyle,
	//timerStyleMobile,
	Title,
	timerStyle,
	timerStyleMobile,
	Wrapper
} from "./styles";
import { Timer } from "./svg";

export const WaterFallSale = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const greenArrow = getImage(waterfallSaleAssets.greenArrow);
	const plusIcon = getImage(waterfallSaleAssets.plusIcon);
	const { isFeatureFlagEnabled } = useEnvContext();
	const { props } = useAppSelector(selectDialogState);
	const [refetchOnFocus, setRefetchOnFocus] = useState(true);
	const { nowTime, authToken } = useWebStoreContext();
	// Temporarily hidden per product request; restore this state with the JSX below
	// to re-enable the Poi's Bounty tag.
	// const { canContribute: isPoisActive } = useAppSelector(
	// 	selectPoisBountyV3State
	// );
	const { data: purchaseOffers, isLoading: isOffersLoading } =
		offersApi.endpoints.getOffers.useQueryState({
			offerType: "singleItem",
			isAuthenticated: !!authToken?.value
		});

	const isPortrait = useMediaQuery("(max-width:733px)");
	const isWaterfallSaleActive = () => {
		return (
			!!authToken?.value && isFeatureFlagEnabled(FeaturesFlags.WATERFALL_SALES)
		);
	};
	const {
		isLoading: isSessionTrackerLoading,
		data,
		isError,
		refetch
	} = useGetFeatureTrackerQuery(
		{
			FeatureType: "waterfall-sale",
			isAuthenticated: !!authToken?.value
		},
		{ skip: !isWaterfallSaleActive(), refetchOnFocus }
	);
	const getOfferbyId = (offerId: string) => {
		return purchaseOffers?.offers.find(
			(offer: IOffer) => offer?.id === offerId
		);
	};

	const handleEnd = () => {
		setTimeout(() => {
			refetch();
		}, 1000);
	};

	const handleCompleted = () => {
		setTimeout(() => {
			refetch();
		}, 5000);
	};

	useEffect(() => {
		if (data?.sessionTracker?.complete) {
			setRefetchOnFocus(false);
		} else {
			setRefetchOnFocus(true);
		}
	}, [data?.sessionTracker]);

	useEffect(() => {
		if (data?.sessionTracker?.complete && !props) {
			handleCompleted();
		}
	}, [data?.sessionTracker, props]);

	useEffect(() => {
		if (data?.success) {
			dispatch(setWaterfallResponse(data));
		}
	}, [data]);

	if (
		isOffersLoading ||
		isSessionTrackerLoading ||
		isError ||
		!data?.sessionTracker
	) {
		return <></>;
	}

	const { sessionTracker } = data;

	return (
		<>
			<Container
				BackgroundImage={getVariantImage(
					sessionTracker?.backgroundV2ImageUrl ||
						sessionTracker?.backgroundImageUrl,
					"{waterfall_variant}",
					isPortrait ? "small" : "large"
				)}
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center"
				}}
			>
				<BgBrush src={isPortrait ? bgBrushMobile : bgBrush} />
				<CountdownV2
					icon={<Timer />}
					text={"Offer ends in:"}
					startTime={nowTime}
					endTime={sessionTracker?.endTime}
					onEnd={handleEnd}
					className={"centeredTimer"}
					labelStyle={{ color: "#EB5757", marginLeft: "0.6em" }}
					style={{
						...(isPortrait ? timerStyleMobile : timerStyle)
					}}
				/>
				<Title BackgroundImage={sessionTracker?.titleImageUrl} />
				<OffersContainer>
					{sessionTracker.tierStatuses?.map(
						(tierStatus: ITierStatus, index: number) => (
							<Wrapper key={index}>
								{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
									<WaterFallCardV2
										saleId={sessionTracker?.saleId}
										tierStatuses={sessionTracker.tierStatuses}
										tierStatus={tierStatus}
										offer={getOfferbyId(tierStatus?.tier?.offerId)}
										endTime={sessionTracker?.endTime}
									/>
								) : (
									<WaterFallCard
										saleId={sessionTracker?.saleId}
										tierStatuses={sessionTracker.tierStatuses}
										tierStatus={tierStatus}
										offer={getOfferbyId(tierStatus?.tier?.offerId)}
									/>
								)}
								{index < sessionTracker.tierStatuses?.length - 1 && (
									<Image
										src={
											sessionTracker.tierStatuses[index + 1]?.tier?.offerId
												? greenArrow
												: plusIcon
										}
									/>
								)}
							</Wrapper>
						)
					)}
				</OffersContainer>

				{/*
					{isFeatureFlagEnabled(FeaturesFlags.UI_V2) && isPoisActive && (
						<ContributeToPoisText style={{ paintOrder: "stroke fill" }}>
							Contribute to Poi’s Bounty
						</ContributeToPoisText>
					)}
				*/}
				<DebugCopyIdButton
					id={sessionTracker.saleId}
					label="SaleID"
					side="left"
					style={{ bottom: "2%", fontSize: "1.4em", zIndex: 1000 }}
				/>
			</Container>
		</>
	);
};
